// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page[data-v-04e78e5b] {\n  width: 375px;\n  height: 500px;\n  overflow: hidden;\n  border: 1px solid #e8e8e8;\n  padding: 10px;\n  border-radius: 10px;\n  margin: 0 auto;\n  position: relative;\n}\n.page > div[data-v-04e78e5b] {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.page > div.cont[data-v-04e78e5b] {\n  overflow-y: auto;\n}", ""]);
// Exports
module.exports = exports;
